import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, ParamMap, Router, Scroll } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface Breadcrumb {
  label: string;
  url?: string;
  externalUrl?: any
}

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);
  breadcrumbs$ = this._breadcrumbs$.asObservable();

  constructor(private router: Router, private route: ActivatedRoute) {
    // 1️⃣ Inizializza i breadcrumbs al primo caricamento
    this._breadcrumbs$.next(this.createBreadcrumbs(this.route.root));

    // 2️⃣ Aggiorna i breadcrumbs durante la navigazione
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd || event instanceof Scroll))
      .subscribe(() => {
        this._breadcrumbs$.next(this.createBreadcrumbs(this.route.root));
      });
  }

  private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    if (route.routeConfig?.data?.['breadcrumb']) {
      const breadcrumbData = route.routeConfig.data['breadcrumb'];
      let label = '';

      if (typeof breadcrumbData === 'function') {
        label = breadcrumbData(route.snapshot.data);
      } else {
        label = breadcrumbData;
      }

      const breadcrumb: Breadcrumb = { label };

      // Controlla se è un URL esterno
      if (route.routeConfig.data['externalUrl']) {

        const extUrl = route.routeConfig.data['externalUrl'];
        let xx:string;
        if (typeof extUrl === 'function') {
          xx = extUrl(route.snapshot.data);
        } else {
          xx = extUrl;
        }
        breadcrumb.externalUrl = xx;
        
      } else {
        const breadcrumbUrl = `${url}/${route.routeConfig.path}`;
        breadcrumb.url = breadcrumbUrl;
      }

      breadcrumbs.push(breadcrumb);
    }

    if (route.firstChild) {
      return this.createBreadcrumbs(route.firstChild, url, breadcrumbs);
    }

    return breadcrumbs;
  }
}
